// Parâmetros por assunto e catálogo de conectores (épico PO1-3258) — endpoints do
// backend_hub. Usar `api` (API_URL): o interceptor injeta o X-Active-Embarcador-Id.
//
//   GET  /parametros/:escopo/formulario?contextoId=   → ParametroFormulario[] (TODO o
//        catálogo do escopo, com ou sem valor gravado)
//   PUT  /parametros/:escopo/lote  { contextoId, valores: [{ nome, valor }] }
//        → { ok, gravados, removidos, mantidos }. Senha com '' mantém a salva; demais
//        com ''/null apagam a linha (volta ao padrão); nome desconhecido → 400
//        { error, rejeitados: [...] }.
//   POST /embarcadores/:embarcadorId/integracoes/:conector/testar { valores: { nome: valor } }
//        → sempre 200 { ok, mensagem, duracaoMs }. conector ∈ protheus|espiao|sefaz|obc.
//
// ParametroFormulario = { idParametro, nome, modulo, classificacao, descricao, tipo,
//   opcoes, sufixo, min, max, placeholder, idValor, valor, hasValue }
// (senha vem com valor:null + hasValue:true/false; nunca o segredo).
import api from "./api";

export const ESCOPOS = ["embarcador", "transportadora", "remetente"];

export async function getFormulario(escopo, contextoId) {
  const { data } = await api.get(`/parametros/${escopo}/formulario`, { params: { contextoId } });
  return Array.isArray(data) ? data : [];
}

export async function salvarLote(escopo, contextoId, valores) {
  const { data } = await api.put(`/parametros/${escopo}/lote`, { contextoId, valores });
  return data;
}

export async function testarConector(embarcadorId, conector, valores) {
  const { data } = await api.post(`/embarcadores/${embarcadorId}/integracoes/${conector}/testar`, {
    valores: valores || {},
  });
  return data;
}

// Mensagem legível para o toast. O 400 do lote traz `rejeitados` (nomes fora do
// catálogo): mostra quais, para o suporte achar rápido.
export function mensagemErroParametros(error, fallback) {
  const payload = error && error.response && error.response.data;
  const doBackend =
    payload && typeof payload === "object"
      ? (typeof payload.error === "string" && payload.error) || (typeof payload.message === "string" && payload.message) || ""
      : typeof payload === "string"
        ? payload
        : "";
  const rejeitados = payload && Array.isArray(payload.rejeitados) ? payload.rejeitados : [];
  const base = doBackend || (error && error.message) || fallback || "Não foi possível concluir a operação.";
  if (!rejeitados.length) return base;
  const nomes = rejeitados.map((r) => (r && typeof r === "object" ? r.nome || JSON.stringify(r) : String(r)));
  return `${base} (${nomes.join(", ")})`;
}
